export const enum FlagTypeEnum {
  SUCCESS = 'success',
  ERROR = 'error',
}
